import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

interface DashboardFiltersProps {
  onFilterChange: (filter: string) => void;
  actionRequiredCount: number;
  pendingCount: number;
  completedCount: number;
  incompleteCount: number;
}

export const DashboardTile = ({
  onFilterChange,
  actionRequiredCount,
  pendingCount,
  completedCount,
  incompleteCount
}: DashboardFiltersProps) => {
  const [selectedFilter, setSelectedFilter] = useState<string>('all');

  const handleFilterChange = (newFilter: string) => {
    setSelectedFilter(newFilter);
    onFilterChange(newFilter);
  };

  return (
    <>
      <Row className='mb-3 site-background'>
        {/* Action Required */}
        <Col md={3}>
          <div onClick={() => handleFilterChange('actions')} className='dashboard-tile'>
            <span className='dashboard-tileCount actionRequiredTile'>{actionRequiredCount}</span>
            <label className='text-break dashboard-tileText'>Action Required</label>
            <div className='dashboard-tileIcon actionRequiredIcon'>
              <div style={{ textAlign: 'center', color: 'white', marginTop: '10px' }}>
                <i className='fa fa-exclamation-triangle'></i>
              </div>
            </div>
          </div>
        </Col>

        {/* Pending */}
        <Col md={3}>
          <div onClick={() => handleFilterChange('pending')} className='dashboard-tile'>
            <span className='dashboard-tileCount pendingTile'>{pendingCount}</span>
            <label className='text-break dashboard-tileText'>Pending</label>
            <div className='dashboard-tileIcon pendingIcon'>
              <div style={{ textAlign: 'center', color: 'white', marginTop: '10px' }}>
                <i className='fa fa-stars'></i>
              </div>
            </div>
          </div>
        </Col>
        {/* Completed */}
        <Col md={3}>
          <div onClick={() => handleFilterChange('complete')} className='dashboard-tile'>
            <span className='dashboard-tileCount completedTile'>{completedCount}</span>
            <label className='text-break dashboard-tileText'>Completed</label>
            <div className='dashboard-tileIcon completedIcon'>
              <div style={{ textAlign: 'center', color: 'white', marginTop: '10px' }}>
                <i className='fa fa-badge-check'></i>
              </div>
            </div>
          </div>
        </Col>
        <Col md={3}>
          <div onClick={() => handleFilterChange('incomplete')} className='dashboard-tile'>
            <span className='dashboard-tileCount incompleteTile'>{incompleteCount}</span>
            <label className='text-break dashboard-tileText'>Incomplete Enrollments</label>
            <div className='dashboard-tileIcon incompleteIcon'>
              <div style={{ textAlign: 'center', color: 'white', marginTop: '10px' }}>
                <i className='fa fa-user-injured'></i>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};
